import type { LineItemNeedingAttention } from './LineItem.ts';

export enum DocumentDrawerDisplayMode {
    FollowReason = 'follow_reason',
    AlwaysEditor = 'always_editor',
}

export type DocumentDrawerOptions = {
    lineItemsNeedingAttention?: LineItemNeedingAttention[];
    allLineItemsMessage?: string;
};

export type DrawerDocument = {
    id: string;
    businessId: string;
    fileName?: string;
    documentDrawerOptions?: DocumentDrawerOptions;
};

export type DrawerAutoAdvance = {
    onDelete: boolean;
    onRecategorize: boolean;
    onArchive: boolean;
    onMarkAsCreditCardStatement: boolean;
    onSave: boolean;
};

export enum DrawerAutoAdvanceTrigger {
    Delete = 'onDelete',
    Recategorize = 'onRecategorize',
    Archive = 'onArchive',
    MarkAsCreditCardStatement = 'onMarkAsCreditCardStatement',
    Save = 'onSave',
}

export const DEFAULT_AUTO_ADVANCE: DrawerAutoAdvance = {
    onDelete: true,
    onRecategorize: false,
    onArchive: false,
    onMarkAsCreditCardStatement: true,
    onSave: false,
};

export type OpenDocumentOptions = {
    documentList?: DrawerDocument[];
    documentDrawerOptions?: DocumentDrawerOptions;
    initialTab?: number;
    displayMode?: DocumentDrawerDisplayMode;
    onClose?: () => void;
    autoAdvance?: Partial<DrawerAutoAdvance>;
};

export type DrawerSession = {
    businessId: string;
    documentId: string;
    documentList: DrawerDocument[];
    documentDrawerOptions?: DocumentDrawerOptions;
    initialTab?: number;
    displayMode: DocumentDrawerDisplayMode;
    autoAdvance: DrawerAutoAdvance;
};

export type DrawerNavigation = {
    total: number;
    currentIndex: number;
    fileName?: string;
    onPrevious: () => void;
    onNext: () => void;
};
